'use client';
import { ZIndexElevations } from './domain.js';

const getDefaultZIndex = (level)=>{
    return ZIndexElevations[level];
};

export { getDefaultZIndex };
//# sourceMappingURL=zIndicies.js.map
